import ScrollManager from './scrollManager';
import OverlayMenuView from './overlayMenuView';
import SearchView from './searchView';
import CarouselView from './carouselView';
import FooterView from './footerView';
import WebToAppBannerView from './webToAppBannerView';
import PersonalityQuizView from './personalityQuizView';
import ArticleDetailView from './articleDetailView';
import ShareUtil from './shareUtil';
import LoadMoreView from './loadMoreView';

const EventEmitter = require('events');

const commonInit = () => {
  window.dispatcher = new EventEmitter();

  const scrollManagerInstance = new ScrollManager();
  const overlayMenuInstance = new OverlayMenuView();
  const carouselInstance = new CarouselView();
  const searchInstance = new SearchView();
  const footerInstance = new FooterView();
  const webToAppBannerInstance = new WebToAppBannerView();
  const personalityQuizInstance = new PersonalityQuizView();
  const shareUtilInstance = new ShareUtil();

  scrollManagerInstance.init();
  overlayMenuInstance.init();
  carouselInstance.init();
  searchInstance.init();
  footerInstance.init();
  webToAppBannerInstance.init();
  personalityQuizInstance.init();
  shareUtilInstance.init();
};

const articleDetailInit = () => {
  const articleDetailInstance = new ArticleDetailView();

  articleDetailInstance.init();
};

const loadMoreInit = () => {
  const loadMoreInstance = new LoadMoreView();

  loadMoreInstance.init();
};

const onReady = () => {
  commonInit();

  const isArticlePage = document.querySelector('.js-article');

  if (isArticlePage) articleDetailInit();

  const isLoadMorePage = document.querySelector('.js-load-more-container');

  if (isLoadMorePage) loadMoreInit();
};


document.addEventListener('DOMContentLoaded', () => {
  onReady();
});
